import React from 'react';

import { LazyApplicationNavigatorPage } from '@confluence/site-settings/entry-points/ApplicationNavigatorPage.ts';
import { ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/applicationNavigatorConstants.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminApplicationNavigatorRoute = () => <LazyApplicationNavigatorPage />;

AdminApplicationNavigatorRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
